import VendorInvoiceContainer from "./VendorInvoiceContainer";
export default VendorInvoiceContainer;
